import Constants from "@/resources/Constants";
import * as Entities from "@/resources/Entities";

import {
  filterCriteria as groupFilterCriteria,
  searchColumnHeaders as groupColumnHeaders,
} from "../Group/inputs";

import {
  filterCriteria as supplierFilterCriteria,
  searchColumnHeaders as supplierColumnHeaders,
} from "../Supplier/inputs";

import {
  filterCriteria as brandFilterCriteria,
  searchColumnHeaders as brandColumnHeaders,
} from "../Brand/inputs";

import {
  filterCriteria as productFilterCriteria,
  searchColumnHeaders as productColumnHeaders,
} from "../Product/inputs";

// Import shared options (from shared file to avoid circular dependency)
import {
  discountTypeOptions,
  sourceTypeOptions,
  effectTypeOptions,
  applyToOptions,
  conditionFieldOptions,
  conditionOperatorOptions,
  stackingBehaviorOptions,
  dayOfWeekOptions,
  defaultEffect,
  defaultCondition,
  defaultConditionGroup,
  defaultBundleGroup,
} from "../DiscountRule/sharedOptions";

// Re-export
export {
  discountTypeOptions,
  sourceTypeOptions,
  effectTypeOptions,
  applyToOptions,
  conditionFieldOptions,
  conditionOperatorOptions,
  stackingBehaviorOptions,
  dayOfWeekOptions,
  defaultEffect,
  defaultCondition,
  defaultConditionGroup,
  defaultBundleGroup,
};

// Page Header
export const pageHeader = {
  title: "MSO Discount Rule",
  isEditorView: true,
  cancelPath: "msoDiscountRules",
  addPath: "msoDiscountRuleEditor",
  buttonLabel: "Save",
};

// Page Header
export const listPageHeader = {
  title: "MSO Discount Rules",
  isEditorView: false,
  buttonLabel: "New",
  routerPath: "msoDiscountRuleEditor",
};

export const filterCriteria = [
  {
    label: "Name",
    code: "name",
    numCharsToSearch: 1,
    field: { type: "input", label: "name" },
    isPartial: true,
  },
  {
    label: "Online Store Name",
    code: "onlineStoreName",
    numCharsToSearch: 1,
    field: { type: "input", label: "name" },
    isPartial: true,
  },
  { label: "Id", code: "_id", field: { type: "input", label: "Id" } },
];

console.log(discountTypeOptions);
export const columnHeaders = [
  {
    id: "open",
    type: "button",
    action: "navigateToEntity",
    position: "sticky",
    iconName: "folder-open",
    ariaLabel: "Open",
  },
  {
    title: "Active",
    id: "isActive",
    type: "checkbox",
  },
  {
    title: "Archived",
    id: "isArchived",
    type: "checkbox",
  },
  {
    title: "Name",
    id: "name",
    size: "large",
  },
  {
    title: "Type",
    id: "discountType",
    type: "select",
    options: discountTypeOptions,
    label: "label",
    size: "medium",
  },
  {
    title: "Start Date",
    id: "schedule.startDate",
    type: "date-extended",
    size: "medium",
  },
  {
    title: "End Date",
    id: "schedule.endDate",
    type: "date-extended",
    size: "medium",
  },
  {
    title: "Description",
    id: "description",
    size: "large",
  },
  {
    title: "Id",
    id: "_id",
  },
];

export const searchColumnHeaders = [
  {
    id: "select",
    type: "button",
    action: "selectItem",
    position: "sticky",
    iconName: "hand-pointer",
    ariaLabel: "Select",
  },
  {
    title: "Name",
    id: "name",
    size: "large",
  },
  {
    title: "Id",
    id: "_id",
  },
];

// Default MSO discount rule
export const defaultSelectedMsoDiscountRule = {
  _id: "NEW",
  name: "",
  onlineStoreName: "",
  description: "",
  code: "",
  discountType: "instant",
  isActive: true,
  priority: 0,
  sourceType: ["pos", "online-store", "kiosk"],
  saleType: "recreational",
  allowMultipleApplications: null,
  startDateTime: null,
  endDateTime: null,
  daysOfWeek: [],
  schedule: {
    daysOfWeek: [],
    timeWindows: [],
  },
  conditions: {
    type: "AND",
    rules: []
  },
  triggers: {
    minQuantity: 0,
    minSpend: 0,
    minCannabisGrams: 0,
    customerConditions: {
      type: "AND",
      rules: []
    }
  },
  effects: [],
  stacking: {
    stackingBehavior: "default",
    excludeTypes: [],
    excludeRuleIds: [],
    onlyStackWithTypes: []
  },
  usageLimits: {
    maxPerOrder: null,
    maxPerCustomer: null,
    maxPerCustomerPerDay: null,
    maxTotalUses: null
  },
  bundleGroups: [],
  tags: [],
  isDeleted: false,
};

